module.exports = __webpack_public_path__ + "img/13.a055b518.jpg";